import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4bfba816")

_pushScopeId("data-v-4bfba816")
const _hoisted_1 = { class: "card-body-accounting" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "default-title" }
const _hoisted_5 = {
  key: 0,
  class: "default-text"
}
const _hoisted_6 = {
  key: 1,
  class: "default-text"
}
const _hoisted_7 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_8 = { class: "default-title" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_10 = {
  key: 0,
  class: "default-text"
}
const _hoisted_11 = {
  key: 1,
  class: "default-text"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "default-title" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "default-text"
}
const _hoisted_17 = {
  key: 1,
  class: "default-text"
}
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "default-title" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "default-text"
}
const _hoisted_22 = {
  key: 1,
  class: "default-text"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "default-title" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "default-text"
}
const _hoisted_28 = {
  key: 1,
  class: "default-text"
}
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "default-title" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_32 = {
  key: 0,
  class: "default-text"
}
const _hoisted_33 = {
  key: 1,
  class: "default-text"
}
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "default-title" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "default-text"
}
const _hoisted_39 = {
  key: 1,
  class: "default-text"
}
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "default-title" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "default-text"
}
const _hoisted_44 = {
  key: 1,
  class: "default-text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('providers.subscription.vatType')) + ":", 1),
        (_ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_Multiselect, {
                id: "vatTypeSelector",
                valueProp: "value",
                label: "name",
                trackBy: "name",
                options: _ctx.vatTypeList,
                modelValue: _ctx.providerVatType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.providerVatType = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateVatType($event)))
              }, null, 8, ["options", "modelValue"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.vatType == _ctx.VatType.NoVat ? _ctx.$t('provider.vatType.noVat') : _ctx.$t('provider.vatType.includeVat')), 1))
      ]),
      (_ctx.vatType == _ctx.VatType.IncVat)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('provider.accounting.vat-percent')) + ":", 1),
              _hoisted_9
            ]),
            _createVNode("div", null, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _withDirectives(_createVNode("input", {
                      min: "0",
                      step: "0.01",
                      max: "100",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.providerVatPercent = $event)),
                      class: "form-control h-auto bookit-input w-100",
                      type: "number",
                      required: "",
                      onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterKeyOnlyNumbersDotComma($event))),
                      onPaste: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotComma && _ctx.filterPastedOnlyNumbersDotComma(...args))),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateCommission($event, true)))
                    }, null, 544), [
                      [_vModelText, _ctx.providerVatPercent]
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.providerVatPercent) + "%", 1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('providers.accounting.receiptSequenceNumber')) + ":", 1),
        (_ctx.receiptSequenceNumber)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "bookit-input form-control",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.receiptSequenceNumber.value = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.receiptSequenceNumber.value]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.receiptSequenceNumber.value), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('providers.accounting.invoiceSequenceNumber')) + ":", 1),
        (_ctx.invoiceSequenceNumber)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_21, [
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "bookit-input form-control",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.invoiceSequenceNumber.value = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.invoiceSequenceNumber.value]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(_ctx.invoiceSequenceNumber.value), 1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('providers.accounting.creditInvoiceSequenceNumber')) + ":", 1),
        (_ctx.creditInvoiceSequenceNumber)
          ? (_openBlock(), _createBlock("div", _hoisted_26, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "bookit-input form-control",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.creditInvoiceSequenceNumber.value = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.creditInvoiceSequenceNumber.value]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_28, _toDisplayString(_ctx.creditInvoiceSequenceNumber.value), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_29, [
        _createVNode("div", _hoisted_30, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('providers.accounting.commission')) + ":", 1),
          _hoisted_31
        ]),
        _createVNode("div", null, [
          (_ctx.editMode)
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _withDirectives(_createVNode("input", {
                  min: "0",
                  step: "0.01",
                  max: "100",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.commissionPercent = $event)),
                  class: "form-control h-auto bookit-input",
                  type: "number",
                  required: "",
                  onKeypress: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterKeyOnlyNumbersDotComma($event))),
                  onPaste: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotComma && _ctx.filterPastedOnlyNumbersDotComma(...args))),
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateCommission($event)))
                }, null, 544), [
                  [_vModelText, _ctx.commissionPercent]
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_33, _toDisplayString(_ctx.commissionPercent) + "%", 1))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_34, [
      _createVNode("div", _hoisted_35, [
        _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('providers.accounting.invoiceReceiptSequenceNumber')) + ":", 1),
        (_ctx.invoiceReceiptSequenceNumber)
          ? (_openBlock(), _createBlock("div", _hoisted_37, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "bookit-input form-control",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.invoiceReceiptSequenceNumber.value = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.invoiceReceiptSequenceNumber.value]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(_ctx.invoiceReceiptSequenceNumber.value), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_40, [
        _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('providers.accounting.perfomaInvoiceSequenceNumber')) + ":", 1),
        (_ctx.perfomaInvoiceSequenceNumber)
          ? (_openBlock(), _createBlock("div", _hoisted_42, [
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_43, [
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "bookit-input form-control",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.perfomaInvoiceSequenceNumber.value = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.perfomaInvoiceSequenceNumber.value]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_44, _toDisplayString(_ctx.perfomaInvoiceSequenceNumber.value), 1))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})